import { type FC, useContext, createContext, type ReactNode } from 'react';
import { type PhotoLike } from 'dibs-interiors-photos/exports/usePhotosLikeDataRefetch.ts';

export type PhotoLikesMap = Map<string, PhotoLike & { totalPhotoLikes: number }>;

const PhotoLikesContext = createContext<PhotoLikesMap | null>(null);

type ProviderProps = {
    photoLikesMap: PhotoLikesMap | null;
    children: ReactNode;
};

export const PhotoLikesContextProvider: FC<ProviderProps> = ({ photoLikesMap, children }) => {
    return <PhotoLikesContext value={photoLikesMap}>{children}</PhotoLikesContext>;
};

export const usePhotoLikesContext = (): PhotoLikesMap | null => useContext(PhotoLikesContext);
